'use client';

import { c as _c } from "react/compiler-runtime";
import { PopoverGroup } from '@headlessui/react';
import { ArrowRightIcon } from '@heroicons/react/24/solid';
import { Link } from '../../../../actions/Link';
import { mentoringStaffLink } from '../_components/NavigationItems';
import { AboutUs } from '../_sections/AboutUs';
import { ManageSiteSection } from '../_sections/ManageSite';
import { OfertaSection } from '../_sections/Oferta';
export function NavbarDesktop(t0) {
  const $ = _c(12);
  const {
    canManageSite,
    canManagePayments
  } = t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <AboutUs />;
    t2 = <OfertaSection />;
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Link href="/kontakt"><span className="font-medium text-slate-900 text-sm hover:text-algosecondary hover:underline">Kontakt</span></Link>;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Link href="/baza"><span className="flex items-center gap-x-1 text-center font-medium text-algoprimary text-sm hover:underline">Baza wiedzy<ArrowRightIcon className="h-3 w-3 shrink-0" aria-hidden="true" /></span></Link>;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="mt-0.5 flex items-center gap-8">{t4}<Link href="/app"><span className="flex items-center gap-x-1 font-medium text-algoprimary text-sm hover:underline">Aplikacja<ArrowRightIcon className="h-3 w-3" aria-hidden="true" /></span></Link></div>;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== canManagePayments) {
    t6 = canManagePayments ? <Link href={mentoringStaffLink.href}><span className="font-medium text-algoprimary text-sm hover:text-algosecondary hover:underline">{mentoringStaffLink.name}</span></Link> : null;
    $[5] = canManagePayments;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== canManageSite) {
    t7 = canManageSite && <ManageSiteSection />;
    $[7] = canManageSite;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== t6 || $[10] !== t7) {
    t8 = <PopoverGroup className="hidden items-center lg:flex lg:gap-x-8">{t1}{t2}{t3}{t5}{t6}{t7}</PopoverGroup>;
    $[9] = t6;
    $[10] = t7;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  return t8;
}